<template>
    <div class="container">
        <van-loading type="spinner" color="#1989fa" />
    </div>
</template>

<script>
import { getOpenId } from "@/http/salary";
import Vue from 'vue';
import { Loading } from 'vant';

Vue.use(Loading);


export default {
    data() {
        return {
            code:'1',
            openid:'',
            history: $cookies.get('history')
        };
    },
    created(){
        this.init()
        // let url = window.location.href;
        // if(url.search('platform.engma.net') != -1  && !url.search('open') != -1 ){
        //     this.init()
        // }else{
        //     if(this.$store.state.openid == ''){
        //         window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx815dbde2374f3068&response_type=code&scope=snsapi_base&redirect_uri=http://testwx-platform.engma.net/#/&state=STATE#wechat_redirect"
        //     }
        // }
    },
    components: {},
    methods: {
        async init(){
            let _this = this
            const res = await getOpenId("/wxAuth/codeToOpenid",{code:_this.GetQueryString('code')});
            if(res.msg == 'success'){
                _this.$store.dispatch('SAVEUSERACTION',res.data)
                _this.openid = res.data
                _this.code = _this.GetQueryString('code')
                _this.$router.push(`./${_this.$cookies.get('history')}`)
            }
        },
        GetQueryString(name){
            var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);//search,查询？后面的参数，并匹配正则
            if(r!=null)return  unescape(r[2]); return null;
        }
    },
};
</script>

<style lang="less" scoped>
.container{
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
